import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-6 py-24 text-center">
      <ShoppingCart className="h-16 w-16 text-slate-300" data-testid="payment-cancel-icon" />
      <h1 className="mt-6 font-head text-2xl font-extrabold text-slate-900">Paiement annulé</h1>
      <p className="mt-2 text-slate-500">Votre panier a été conservé. Vous pouvez reprendre votre commande quand vous le souhaitez.</p>
      <Link to="/catalogue"><Button className="mt-8 rounded-full bg-blue-600 px-8 py-6 text-white hover:bg-blue-700">Reprendre mes achats</Button></Link>
    </div>
  );
}
